class FreshDeskForm extends HTMLElement {
    constructor() {
      super();
      this.apiKey = 'EJUNdyYtGFBFwdYRkOHk';
      this.domain = 'https://sistaco.freshdesk.com';
    }
  
    connectedCallback() {
      this.submitButton = this.querySelector('.freshdesk-submit');
      this.submitButton?.addEventListener('click', this.handleSubmit.bind(this));
    }
  
    getFieldName(input) {
      return input.getAttribute('data-name') || input.id.charAt(0).toUpperCase() + input.id.slice(1);
    }
  
    showSuccess(input) {
      const formControl = input.parentElement;
      formControl.className = input.id === "typeofinquiry" 
        ? 'Form__Select Select Select--primary Form__Item success' 
        : 'Form__Item success';
    }
  
    showError(input, message) {
      const formControl = input.parentElement;
      formControl.className = input.id === "typeofinquiry" 
        ? 'Form__Select Select Select--primary Form__Item error' 
        : 'Form__Item error';
      const small = formControl.querySelector('small');
      if (small) small.innerText = message;
    }
  
    checkEmail(input) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(input.value.trim())) {
        this.showSuccess(input);
        return true;
      } else {
        this.showError(input, 'Email is not valid');
        return false;
      }
    }
  
    checkRequired(inputArr) {
      let allValid = true;
      inputArr.forEach(input => {
        if (input.value.trim() === '') {
          this.showError(input, `${this.getFieldName(input)} is required`);
          allValid = false;
        } else {
          this.showSuccess(input);
        }
      });
      return allValid;
    }
  
    async handleSubmit(e) {
      e.preventDefault();
      
      const requiredFields = [
        this.querySelector('#typeofinquiry'),
        this.querySelector('#firstname'),
        this.querySelector('#lastname'),
        this.querySelector('#email'),
        this.querySelector('#mainmessage')
      ].filter(Boolean);
  
      if (!this.checkRequired(requiredFields)) return;
      if (!this.checkEmail(this.querySelector('#email'))) return;
  
      const loader = this.querySelector('.loadersmall');
      const submitButton = this.querySelector('.freshdesk-submit');
      
      if (loader) loader.style.display = 'block';
      if (submitButton) submitButton.disabled = true;
  
      try {
        const formData = this.prepareFormData();
        await this.submitForm(formData);
        this.showSuccessMessage();
      } catch (error) {
        this.showErrorResponse(error);
      } finally {
        if (loader) loader.style.display = 'none';
      }
    }
  
    prepareFormData() {
      const formData = new FormData();
      const orderNumber = this.querySelector("[name='ordernumber']")?.value;
      const typeOfInquiry = this.querySelector("[name='typeofinquiry']")?.value;
      
      formData.append('name', `${this.querySelector('.firstname')?.value} ${this.querySelector('.lastname')?.value}`);
      formData.append('description', this.querySelector('.mainmessage')?.value);
      formData.append('email', this.querySelector('.email')?.value);
      formData.append('subject', orderNumber 
        ? `${typeOfInquiry} ORDER NO SG #${orderNumber}` 
        : `${typeOfInquiry}| SG`);
      formData.append('group_id', 65000072515);
      formData.append('priority', '2');
      formData.append('status', '2');
  
      const fileInput = this.querySelector('#myFile');
      if (fileInput?.files.length > 0) {
        Array.from(fileInput.files).forEach(file => {
          formData.append("attachments[]", file);
        });
      }
  
      return formData;
    }
  
    async submitForm(formData) {
      const response = await fetch(`${this.domain}/api/v2/tickets`, {
        method: 'POST',
        headers: {
          'Authorization': 'Basic ' + btoa(this.apiKey + ":x")
        },
        body: formData
      });
  
      if (!response.ok) {
        const error = new Error(response.statusText);
        error.response = response;
        throw error;
      }
  
      return response.json();
    }
  
    showSuccessMessage() {
      this.classList.add('form-success');

      const resultDiv = this.querySelector('.freshdesk-form-result');
      if (resultDiv) resultDiv.classList.remove('hidden');
    }
  
    async showErrorResponse(error) {
      const resultDiv = this.querySelector('#result') || document.createElement('div');
      const codeDiv = this.querySelector('#code') || document.createElement('div');
      const responseDiv = this.querySelector('#response') || document.createElement('div');
      
      resultDiv.textContent = 'Error';
      codeDiv.textContent = error.response?.status || 'Unknown';
      
      try {
        const errorData = await error.response?.json();
        const xRequestId = error.response?.headers.get('X-Request-Id');
        
        responseDiv.innerHTML = `
          Error Message: <b style="color: red">${errorData?.message || error.message}</b>.<br/>
          Your X-Request-Id is: <b>${xRequestId || 'Unknown'}</b>. 
          Please contact support@freshdesk.com with this id for more information.
        `;
      } catch (e) {
        responseDiv.innerHTML = `
          An error occurred: <b style="color: red">${error.message}</b>
        `;
      }
      
      if (!this.querySelector('#result')) this.appendChild(resultDiv);
      if (!this.querySelector('#code')) this.appendChild(codeDiv);
      if (!this.querySelector('#response')) this.appendChild(responseDiv);
    }
  }
  
  customElements.define('fresh-desk-form', FreshDeskForm);